import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';

import { SourceOfPick } from '../betslip-base/models/pick-models';
import { MarketHelpComponent } from './market-help/market-help.component';
import { OptionComponent } from './option.component';

@Component({
    selector: 'ms-player-outcome-option-group',
    templateUrl: './player-outcome-option-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MarketHelpComponent, OptionComponent],
})
export class PlayerOutcomeOptionGroupComponent {
    @Input() event: EventModel;
    @Input() tracking: string;
    @Input() trackingModuleType = '';
    @Input() optionGroup: EventOptionGroup;
    @Input() showMarketHelp: boolean;
    @Input() crmPromotedOptionIdsMap: { [optionId: number]: number } = {};
    @Input() eventHelpText?: string;
    @Input() sourceOfPick = SourceOfPick.Other;
    @Input() betDetails = '';
}
